import { isDevelopment } from '@/config';

const BASE_ROUTES = {
  application: '/application/:applicationId',
};

export const ROUTES = {
  ...(isDevelopment() && {
    test: '/test',
    error: '/error',
  }),

  shortener: '/l/:code',
  login: '/login',
  institutionLogin: '/institution-login',
  unauthenticated: '/unauthenticated',
  applicationTerminated: '/application-terminated',
  potentialTermination: '/potential-termination',
  invitationLocked: '/invitation-locked',

  home: '/',
  dashboard: '/dashboard',
  missingItems: '/missing-items/:missingItemId',
  missingItemsReviewAndSubmit: '/missing-items/review-and-submit',
  application: BASE_ROUTES.application,
  section: `${BASE_ROUTES.application}/section/:sectionId`,
  questions: `${BASE_ROUTES.application}/questions`,
  signature: `${BASE_ROUTES.application}/signature`,
  authorization: `${BASE_ROUTES.application}/authorization`,
  reviewAndSubmit: `${BASE_ROUTES.application}/review-and-submit`,
  noPendingApplications: '/no-pending-applications',
};
